module.exports = __webpack_public_path__ + "static/media/radioactive-materials-test-add.07e3babb.svg";